<template>
	<div
		class="g-block-video-list"
		:class="{
			'g-block-video-list--edit': editable,
			'is-active': editable && active,
			'g-block-video-list--h5': h5,
			'g-block-video-list--card': blockStyle.showCard,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-video-list__card"
			:style="cardStyle"
		>
			<div class="g-block-video-list__list">
			<div
				v-for="item in items"
				:key="item.id"
				class="g-block-video-list__item"
			>
				<div
					class="g-block-video-list__thumb"
					:style="thumbStyle"
				>
					<img
						v-if="getCoverUrl(item)"
						:src="getCoverUrl(item)"
						alt=""
					/>
					<i v-else class="mbm-iconfont mbm-shipin"></i>
					<span
						v-if="shouldShowPlayIcon"
						class="g-block-video-list__play"
						role="button"
						aria-label="播放视频"
						@click="onItemClick(item, $event)"
					>
						<span class="g-block-video-list__triangle"></span>
					</span>
					<span class="g-block-video-list__duration">{{ getDurationText(item) }}</span>
				</div>
				<div
					class="g-block-video-list__title"
					:style="{ color: item.titleColor }"
				>
					{{ item.title }}
				</div>
				<div
					class="g-block-video-list__desc"
					:style="{ color: item.descColor }"
				>
					{{ item.description }}
				</div>
			</div>
		</div>
		</div>

		<div v-if="playingUrl" class="g-block-video-list__player">
			<video
				ref="playerEl"
				class="g-block-video-list__player-video"
				:src="playingUrl"
				controls
				playsinline
				@ended="onPlayEnded"
			></video>
			<i class="mbm-iconfont mbm-guanbi g-block-video-list__close" @click="stopPlay"></i>
		</div>
	</div>
</template>

<script>
	import baseFunc from '../../../../config/base_func.js';
	import {
		getVideoListBlockStyle,
		getVideoListCoverUrl,
		getVideoListVideoUrl,
		normalizeVideoListData,
	} from '../../../utils/videoList.js';

	export default {
		name: 'GVideoListShell',
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
			idKey: {
				type: String,
				default: '',
			},
			showPlayIcon: {
				type: Boolean,
				default: null,
			},
		},
		emits: ['select'],
		data() {
			return {
				playingUrl: '',
				permissionRequests: {},
				currentPlayingItem: null,
			};
		},
		computed: {
			normalizedData() {
				return normalizeVideoListData(this.data);
			},
			items() {
				return this.normalizedData.items;
			},
			blockStyle() {
				return getVideoListBlockStyle(this.data, { h5: this.h5 });
			},
			thumbStyle() {
				return {
					aspectRatio: this.blockStyle.thumbAspectRatio,
					borderRadius: this.blockStyle.videoBorderRadius,
				};
			},
			cardStyle() {
				if (!this.blockStyle.showCard) {
					return {};
				}
				return {
					borderRadius: this.blockStyle.cardBorderRadius,
					padding: this.blockStyle.cardPadding,
				};
			},
			isPlayable() {
				return this.editable || this.h5;
			},
			shouldShowPlayIcon() {
				return this.showPlayIcon === null ? this.isPlayable : this.showPlayIcon;
			},
		},
		beforeUnmount() {
			this.stopPlay();
		},
		methods: {
			getCoverUrl(item) {
				return getVideoListCoverUrl(item);
			},
			getDurationText(item) {
				return item.video?.durationText || '00:00';
			},
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onItemClick(item, e) {
				if (!this.isPlayable) return;
				e?.stopPropagation?.();
				const url = getVideoListVideoUrl(item);
				if (!url) return;
				this.currentPlayingItem = item;
				const itemId = item.video?.id;
				if (this.h5 && itemId && !this.permissionRequests[itemId]) {
					this.permissionRequests[itemId] = true;
					this.requestPlayPermission(item, url).then(() => {
						this.$nextTick(() => {
							this.$refs.playerEl?.play?.();
						});
					}).catch((err) => {
						this.permissionRequests[itemId] = false;
						this.$refs.playerEl?.pause?.();
						this.$message.error(err.data?.message || '请求失败');
					});
				} else {
					this.playingUrl = url;
					this.$nextTick(() => {
						this.$refs.playerEl?.play?.();
					});
				}
			},
			//访问路径中取指定的值
			getQueryStringByChannel(name) {
				const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
				if (!window.location.href.split('?')[1]) {
					return null
				}
				const re = window.location.href.split('?')[1].match(reg)
				if (re != null) return unescape(re[2])
				return null
			},
			requestPlayPermission(item, fallbackUrl) {
				return this.$apiRequest.post('/api/getMediaPlayPermissions', {
					attach_id: item.video.id,
					id_key: this.idKey,
					unique: '',
					app_type:1,
					p_key: this.getQueryStringByChannel('p_key')==null?'':this.getQueryStringByChannel('p_key'),
				}).then(res => {
					if (res.data?.play_url) {
						this.playingUrl = baseFunc.getQiniusign(res.data.play_url);
					} else {
						this.playingUrl = fallbackUrl;
					}
				});
			},
			onPlayEnded() {
				this.stopPlay();
			},
			stopPlay() {
				const el = this.$refs.playerEl;
				if (el) {
					el.pause();
				}
				this.playingUrl = '';
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-video-list {
		width: 100%;
		box-sizing: border-box;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

	}

	.g-block-video-list__card {
		box-sizing: border-box;
		width: 100%;

		.g-block-video-list--card & {
			background: #fff;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		}
	}

	.g-block-video-list__list {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
		width: 100%;

		.g-block-video-list--h5 & {
			gap: 0.24rem;
		}
	}

	.g-block-video-list__item {
		min-width: 0;
	}

	.g-block-video-list__thumb {
		position: relative;
		width: 100%;
		height: auto;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 28px;
			color: #bfbfbf;
		}

		.g-block-video-list--h5 & i {
			font-size: 0.56rem;
		}
	}

	.g-block-video-list__play {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		margin: -20px 0 0 -20px;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.45);
		cursor: pointer;
		transition: background 0.2s, transform 0.2s;

		

		.g-block-video-list--h5 & {
			width: 0.8rem;
			height: 0.8rem;
			margin: -0.4rem 0 0 -0.4rem;
		}
	}

	.g-block-video-list__triangle {
		display: block;
		width: 0;
		height: 0;
		margin-left: 3px;
		border-top: 7px solid transparent;
		border-bottom: 7px solid transparent;
		border-left: 11px solid #fff;

		.g-block-video-list--h5 & {
			margin-left: 0.06rem;
			border-top-width: 0.14rem;
			border-bottom-width: 0.14rem;
			border-left-width: 0.22rem;
		}
	}

	.g-block-video-list__duration {
		position: absolute;
		left: 8px;
		bottom: 8px;
		z-index: 2;
		padding: 2px 6px;
		border-radius: 4px;
		background: rgba(0, 0, 0, 0.55);
		color: #fff;
		font-size: 11px;
		line-height: 1.4;
		pointer-events: none;

		.g-block-video-list--h5 & {
			left: 0.16rem;
			bottom: 0.16rem;
			padding: 0.04rem 0.12rem;
			border-radius: 0.08rem;
			font-size: 0.22rem;
		}
	}

	.g-block-video-list__title {
		margin-top: 8px;
		font-size: 14px;
		font-weight: 600;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.g-block-video-list--h5 & {
			margin-top: 0.16rem;
			font-size: 0.28rem;
		}
	}

	.g-block-video-list__desc {
		font-size: 12px;
		line-height: 1.5;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.g-block-video-list--h5 & {
			margin-top: 0.08rem;
			font-size: 0.24rem;
		}
	}

	.g-block-video-list__player {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 9999;
		width: 100%;
		height: 100%;
		background: #000;
	}

	.g-block-video-list__player-video {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.g-block-video-list__close {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 40px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		background: rgba(0, 0, 0, 0.5);
		border-radius: 50%;
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		z-index: 1;
	}
</style>
